import React from 'react'
import * as s from './style.module.css';

export default function index({ x = 1, y = 1, color }) {
  return (
    <div style={{ width: x * 15 + 'px', height: y * 15 + 'px' }} className={`${s.dots} ${color && s[color]}`}>
    </div>
  )
}
